import { useCallback, useEffect, useState } from 'react'

/**
 * Estado compartilhado para fluxos de upsell render-only.
 * Só abre / avança passos quando `enabled` é true.
 */
export function useUpsellFlowState({
  enabled = false,
  initialStep,
  initialTab = 'packages',
}) {
  const [currentStep, setCurrentStep] = useState(null)
  const [activeTab, setActiveTab] = useState(initialTab)

  const closeFlow = useCallback(() => {
    setCurrentStep(null)
  }, [])

  const openFlow = useCallback(() => {
    if (!enabled) {
      return false
    }

    setActiveTab(initialTab)
    setCurrentStep(initialStep)
    return true
  }, [enabled, initialStep, initialTab])

  useEffect(() => {
    if (!enabled) {
      setCurrentStep((previousStep) =>
        previousStep?.startsWith('success') ? previousStep : null,
      )
    }
  }, [enabled])

  const isStep = useCallback(
    (step) => {
      if (step?.startsWith('success')) {
        return currentStep === step
      }

      return enabled && currentStep === step
    },
    [enabled, currentStep],
  )

  const goToStep = useCallback(
    (step) => {
      if (!enabled) {
        return
      }

      setCurrentStep(step)
    },
    [enabled],
  )

  const openSuccessStep = useCallback((step) => {
    if (!step) {
      return false
    }

    setCurrentStep(step)
    return true
  }, [])

  const isSuccessStepActive = currentStep?.startsWith('success') ?? false

  return {
    activeTab,
    setActiveTab,
    closeFlow,
    openFlow,
    isStep,
    goToStep,
    openSuccessStep,
    currentStep,
    isSuccessStepActive,
  }
}
